import { Streamdown } from "streamdown";

export function reportLinkUrl(value: string): string {
	if (value.startsWith("#")) return value;
	try {
		const url = new URL(value);
		return ["http:", "https:"].includes(url.protocol) && !url.username && !url.password ? url.href : "";
	} catch { return ""; }
}

export function SafeReportMarkdown({ children }: { children: string }) {
	return <Streamdown mode="static" skipHtml remarkRehypeOptions={{ allowDangerousHtml: false }}
		disallowedElements={["img", "iframe", "script", "style", "object", "embed", "form", "input", "video", "audio"]}
		urlTransform={reportLinkUrl}
		components={{ a: ({ href, children }) => href
			? <a href={href} target="_blank" rel="noopener noreferrer" className="text-text-link underline underline-offset-2">{children}</a>
			: <span>{children}</span> }}
	>{children}</Streamdown>;
}
